import React from 'react';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';

import useIsScrolled from 'apps/promo/hooks/useIsScrolled';
import clsx from 'clsx';

import styles from './LightDiskButton.module.css';
import { LightIcon } from '../LightIcon/LightIcon';

const variantClass = {
    primary: styles.primary,
    secondary: styles.secondary,
    tertiary: undefined,
};

const DiskButtonPure = ({
    iconName = 'cross',
    iconColor = 'primary',
    size = 'tight',
    variant,
    type,
    raised,
    to,
    href,
    onClick,
    id,
    marginRight,
    dataTestId,
}) => {
    const isScrolled = useIsScrolled();
    const computedRaised = raised ?? isScrolled;

    const commonProps = {
        className: clsx(styles.button, variant && variantClass[variant], size === 'small' && styles.small, computedRaised && styles.raised),
        style: marginRight ? { marginRight } : undefined,
        'data-testid': dataTestId,
        onClick,
        id,
    };
    const icon = <LightIcon name={iconName} color={iconColor} size={size === 'small' ? '16px' : '24px'} />;

    if (type === 'tagA') {
        return (
            <a {...commonProps} href={href}>
                {icon}
            </a>
        );
    }
    if (type === 'button') {
        return (
            <button {...commonProps} type="button">
                {icon}
            </button>
        );
    }
    return (
        <Link {...commonProps} to={to}>
            {icon}
        </Link>
    );
};
export const LightDiskButton = React.memo(DiskButtonPure);

LightDiskButton.propTypes = {
    // type: <Link>(default) or <a> (type === 'tagA') or <button> (type === 'button')
    type: PropTypes.oneOf(['tagA', 'button']),
    variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
    size: PropTypes.oneOf(['small', 'tight', 'fit']),
    raised: PropTypes.bool,
    to: PropTypes.string,
    href: PropTypes.string,
    onClick: PropTypes.func,
    iconName: PropTypes.string,
    iconColor: PropTypes.string,
    id: PropTypes.string,
    marginRight: PropTypes.string,
    dataTestId: PropTypes.string,
};
